import React, { FC } from "react";
import "./style.scss";

type EstablishErrorProps = {
  isEnabled: boolean;
  errorText?: string;
};

// TODO:Error時の表示切替の値を受け取れるように
export const EstablishError: FC<EstablishErrorProps> = (props) => {
  const { isEnabled, errorText } = props;
  if (isEnabled) {
    return <span className="establishError">{errorText}</span>;
  }
  return null;
};
